import { Navigation, ContentfulQueryKeys, contentful } from '@oresundsbron/api';
import { NavigationFilter } from '@oresundsbron/api/src/contentful/queries/Navigation';
import { useQuery } from '@tanstack/react-query';
import { useRouter } from 'next/router';
import { contentfulReqV2 } from '~/lib/api/server';

export function useNavigation(type: Navigation['type']) {
  const { locale, isPreview } = useRouter();

  const filter: NavigationFilter = { locale, preview: isPreview, type };
  const reqPromise = contentfulReqV2();

  const query = useQuery<Navigation>(
    ContentfulQueryKeys.Navigation({ locale, type, preview: isPreview }),
    async () => {
      const req = await reqPromise;
      return contentful.NavigationV2.get(filter)(req);
    }
  );

  return query.data;
}
